import React, {
  useState, useEffect, useCallback,
  useRef,
} from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withI18n } from 'react-i18next';
import CssBaseline from '@material-ui/core/CssBaseline';
import withWidth, { isWidthDown, isWidthUp } from '@material-ui/core/withWidth';
import { useDispatch, useSelector } from 'react-redux';
import { Menu } from '@/components/Layout/Menu/Menu';
import { TopAdvertisementHandler } from '@/pages/advertisement/TopAdvertisementHandler';
import Trakto from '@/media/partners/traktoHG.svg';
import Cobrefacil from '@/media/partners/cobrefacilHG.svg';
import Creditas from '@/media/partners/creditasHG.svg';
import styles, { Styles } from './styles';
import { useHistory, useLocation } from 'react-router';
import { TitanAdvertisementModal } from '@/pages/sites/components/TitanAdvertisementModal';
import {
  requestGetProEmailList,
} from '@/redux/actions/emails';
import { enqueueSnackbar } from '@/redux/actions/notifications';
import { notifierError } from '@/utils/Application/notifier';
import { ERROR_GET_PRO_EMAILS_LIST } from '@/redux/actions/actionsTypes';
import { useMenu } from '@/hooks/useMenu';
import HeaderV2 from '../Menu/HeaderV2/HeaderV2';
import { SERVICE_STATUS_URL } from '@/config/urls/statusHGUrls';
import { LOGOUT_URL } from '@/config/whmcsUrls';
import { MANAGE_USERS_URL } from '@/config/urls/usersUrls';
import { billingAnalytics } from '@/analytics';
import { financialIds, profileIds } from '../Menu/HeaderV2/HeaderV2.enum';
import { track as trackAmplitude } from '@amplitude/analytics-browser';
import {
  AI_AGENTS_EMAIL_ENABLE_FRONT,
  ATIVACAO_ENABLE_AICHAT_GUIDE,
  ATIVACAO_NEW_HEADER_AI_CTA,
  BRAVO_CHANGE_PHONE_FLOW, BRAVO_EMAIL_FLOW, EXPERIENCE_ACCOUNT_SECURITY, FOXTROT_HOME_AI_CONVERSATION_BANNER, NEW_SUPPORT,
} from '@/config/GrowthBook/constants';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import ModalGtm from '@/components/Modal/ModalGtm';
import { executeUniqueEvent } from '@/utils/ThirdParties/tagManager';
import { LogoutModal } from './components/LogoutModal';
import useLocale from '@/hooks/useLocale';
import { Guides } from './components/Guides';
import { merlinActions, preChatActions } from '@/redux/modules';
import { sidebarAnalytics } from '@/analytics/support/sidebar';
import logger from '@/utils/logger';
import { useTickets } from '@/hooks/tickets';
import { PAYPAL_CHECKOUT_SCRIPT_URL } from '@/config/externalScriptsUrl';
import { Tag } from 'gatorcomponents';
import { sessionStorageKeys } from '@/enums/storage/storage.enum';
import { NewAiHeaderButton } from '../Menu/HeaderV2/components/NewAiHeaderButton';
import { AiGuides } from './components/AiGuides';
import { getCookie } from '@/utils/Application/cookies';
import { MaiaIcon, SlideInButton } from '../Menu/HeaderV2/AiChat/AiChat.styles';
import IconAnimation from '@/components/BannerAI/media/AiAnimation.webp';
import MaiaIconImage from '@/media/MaiaIA/iconImage.png';
import { useChatbot } from '@/contexts/Chatbot';
import { IS_PROD } from '@/config';

const partnerImages = {
  trakto: Trakto,
  cobrefacil: Cobrefacil,
  creditas: Creditas,
};

const Template = ({
  classes, width, children, t, beta,
}) => {
  const [asaasVariation] = useState('variation_A');
  const moreThanOneUser = useSelector(state => state.summary.isContacts);
  const { hasRefreshError } = useSelector(state => state.auth);
  const { temporaryDomains } = useSelector(state => state.newDomains);
  const { visibleAiChat, minimizedChat } = useSelector(state => state.merlin);
  const { template: templateLocale, menu: menuLocale } = useLocale();
  const isAccountSecurityEnabled = useFeatureIsOn(EXPERIENCE_ACCOUNT_SECURITY);
  const useNewSupport = useFeatureIsOn(NEW_SUPPORT);
  const enableEmailVerify = useFeatureIsOn(BRAVO_EMAIL_FLOW);
  const enablePhoneVerify = useFeatureIsOn(BRAVO_CHANGE_PHONE_FLOW);
  const enableAiAgents = useFeatureIsOn(AI_AGENTS_EMAIL_ENABLE_FRONT);
  const enableAiConversation = useFeatureIsOn(FOXTROT_HOME_AI_CONVERSATION_BANNER);
  const enabledAiGuide = useFeatureIsOn(ATIVACAO_ENABLE_AICHAT_GUIDE);
  const useNewChat = useFeatureIsOn(ATIVACAO_NEW_HEADER_AI_CTA);
  const viewAiChatGuide = getCookie('viewAiChatGuide');
  const mainRef = useRef(null);

  const [open, setOpen] = useState(isWidthUp('sm', width));
  const isMobile = isWidthDown('sm', width);
  const dispatch = useDispatch();
  const crumbs = useSelector(state => state.breadCrumbs.crumbs);
  const summaryState = useSelector(state => state.summary);
  const preChatState = useSelector(state => state.preChat);
  const { currentChat: currentAiChat } = useSelector(state => state.merlin);
  const { requestTickets } = useTickets({});

  const chatbot = useChatbot();

  const [partner, setPartner] = useState(null);
  const [displayModalTitanAdvertisementHandler, setDisplayModalTitanAdvertisementHandler] = useState(false);

  const bannerTop = '';
  const history = useHistory();
  const location = useLocation();

  const routesWithDisabledHeaderAndMenu = [t('routes.fastcheckout')];

  const disableHeaderAndMenu = routesWithDisabledHeaderAndMenu.includes(`/${history.location.pathname.split('/')[1]}`);
  const redirectedFromHome = location.state && location.state.redirectFromHome;

  const isHomePage = history.location.pathname === t('routes.home');
  const isSitePage = [t('routes.sitesPage'), t('routes.sites')].includes(history.location.pathname);
  const isDomain = history.location.pathname === t('routes.domains');
  const isEmails = history.location.pathname === t('routes.emailsList');
  const isLinkNaBio = history.location.pathname === t('routes.linkNaBio');
  const isHostAndServer = history.location.pathname === t('routes.products');

  const excludeAiHeader = [isHomePage, isSitePage, isDomain, isEmails, isLinkNaBio, isHostAndServer].some(item => item === true);

  const [domainOptions, setDomainOptions] = useState([]);
  const { subscriptions: subscriptionAnalytics } = billingAnalytics;

  const handleClick = ({ id, route, label }) => {
    if (label) {
      trackAmplitude(`click header item ${label}`);
    }

    if (id && id === financialIds.subscriptions) {
      subscriptionAnalytics.subscriptionsMenuClick();
    }

    const shouldOpenNewTab = id && (id === profileIds.serviceStatus || id === profileIds.manageUsers);
    const isLogout = id && (id === profileIds.logout);

    if (shouldOpenNewTab) {
      localStorage.removeItem('token');
      window.open(route);
    }

    if (isLogout) {
      sessionStorage.removeItem(sessionStorageKeys.chatOpenedBefore);
      localStorage.removeItem('token');
      window.location = route;
    }

    if (!shouldOpenNewTab && !isLogout) {
      if (currentAiChat.fullScreen) {
        if (chatbot.isActive) {
          chatbot.toggleFullscreen(false);
        } else {
          dispatch(merlinActions.inhouse.toggleFullScreen());
        }
      }

      if (useNewSupport && route === t('routes.help')) {
        try {
          const emailVerify = enableEmailVerify ? summaryState.emailVerified : true;
          const phoneVerify = enablePhoneVerify ? summaryState.phoneNumberVerified : true;
          const contactsVerified = emailVerify && phoneVerify;

          if (!contactsVerified) {
            preChatState.screenToShowInPreChat !== 'problemSolved' && dispatch(preChatActions.preChat.setScreen('triage'));
          }

          dispatch(preChatActions.preChat.setShowPreChat(true));
          requestTickets();
          dispatch(preChatActions.productByStatus.request({ withCancelled: true, withPending: false }));
        } catch (e) {
          logger.error('Error on Template - Support button', e);
        }

        sidebarAnalytics.newSupportAnalytics('SUPPORT', 'SUPPORT');
        return;
      }

      history.push(route);
    }
  };

  const menu = useMenu({
    moreThanOneUser, handleClick, profileIds, MANAGE_USERS_URL,
  });

  const [eventReady, setEventReady] = useState({
    one: false,
    two: false,
  });
  const allEmails = useSelector(state => state.emails.proEmailList);
  const domainWithoutEmail = allEmails.filter(item => item.type === 'domain' && !!item.domain && item.status === 'Active');

  const typeAdvertisement = 'Top Banner';

  const loadPaypal = useCallback(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'paypal-objects-checkout';
    script.src = PAYPAL_CHECKOUT_SCRIPT_URL;
    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    if (!window.paypal && !document.getElementById('paypal-objects-checkout')) {
      loadPaypal();
    }
  }, [loadPaypal]);

  useEffect(() => {
    switch (bannerTop) {
      case 'cobre_facil': return setPartner('cobrefacil');
      case 'trakto': return setPartner('trakto');
      default: return setPartner(null);
    }
  }, [bannerTop]);

  useEffect(() => {
    if (!isMobile) {
      setOpen(true);
    }
  }, [isMobile]);

  useEffect(() => {
    if (!eventReady.one && isSitePage && domainOptions.length > 0) {
      executeUniqueEvent(t('titanAdvertisement.modalGtm.event.one'));
      setEventReady({ ...eventReady, one: true });
    }
  }, [t, eventReady, isSitePage, domainOptions]);

  useEffect(() => {
    if (!eventReady.two && isSitePage && domainWithoutEmail) {
      executeUniqueEvent(t('titanAdvertisement.modalGtm.event.two'));
      setEventReady({ ...eventReady, two: true });
    }
  }, [t, eventReady, isSitePage, domainWithoutEmail]);

  const handleToggleMenu = useCallback(() => {
    setOpen(!open);
  }, [open]);

  useEffect(() => {
    if (isSitePage) {
      dispatch(requestGetProEmailList(28)).then((response) => {
        if (response.type === ERROR_GET_PRO_EMAILS_LIST) {
          dispatch(enqueueSnackbar(t('proEmail.failedToLoadList'), notifierError));
          return null;
        }
        setDomainOptions(response.data.filter((item) => {
          const temporaryDomainsList = temporaryDomains.map(tempDomainItem => tempDomainItem.domain);

          const isActive = item.status && item.status.toLowerCase() === 'active';
          const isConfigured = item.configured;
          const isTempDomain = temporaryDomainsList.includes(item.domain);

          return isActive && !isConfigured && !isTempDomain;
        }));
      });
    }
  }, [dispatch, t, isSitePage, temporaryDomains]);

  useEffect(() => {
    // Note: Since we cant put window.Chatbot.iframeInstance in dependency array (he can be undefined if window.Chatbot dont exist yet) we create a interval to check if it exists
    if (!window.Chatbot) return;
    const handleIframeAppend = () => {
      if (window.Chatbot.iframeInstance && window.Chatbot.appendIframe) {
        !IS_PROD && console.log('[PORTAL] - Appending iframe');
        window.Chatbot.appendIframe(mainRef);
      }
    };

    handleIframeAppend();

    const intervalId = setInterval(() => {
      if (window.Chatbot.iframeInstance) {
        handleIframeAppend();
        clearInterval(intervalId);
      }
    }, 100);

    // Cleanup
    return () => {
      clearInterval(intervalId);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderMenu = useCallback(() => (
    <Menu
      items={menu.items({ asaasVariation })}
      open={open}
      onMenuClick={handleToggleMenu}
    />
  ), [
    handleToggleMenu,
    open,
    menu,
    asaasVariation,
  ]);

  const getHeaderV2Props = () => {
    const defaultProps = {
      onToggleMenu: handleToggleMenu,
      routeMyData: t('routes.myData'),
      labelMyData: t('menu.myData'),
      routeChangePassword: t('routes.changePassword'),
      labelChangePassword: t('menu.changePassword'),
      routeAccountSecurity: t('routes.accountSecurity'),
      labelAccountSecurity: t('menu.accountSecurity'),
      routeServicesStatus: SERVICE_STATUS_URL,
      labelServicesStatus: t('menu.servicesStatus'),
      routeLogout: LOGOUT_URL,
      labelLogout: t('menu.quit'),
      moreThanOneUser,
      routeManageUsers: MANAGE_USERS_URL,
      routeSupport: t('routes.help'),
      labelSupport: t('menu.help'),
      labelManageUsers: t('menu.manageUsers'),
      routesInvoices: `${t('routes.invoices')}${t('routes.unpaid')}`,
      labelInvoices: t('menu.billing'),
      rotutesSubscriptions: t('routes.subscriptions'),
      labelSubscriptions: t('menu.subscriptions'),
      routeCreditCard: t('routes.creditcard'),
      labelCreditCard: t('menu.creditCard'),
      financialLabel: t('menu.newBilling'),
      profileLabel: t('menu.profile'),
      myAlertsLabel: t('menu.myAlerts'),
      allNotificationsLabel: t('menu.allNotifications'),
      ticketNotificationsLabel: t('menu.ticketNotifications'),
      seeMoreLabel: t('menu.seeMore'),
      alertsTooltipLabel: t('menu.alertsTooltip'),
      noNotificationsLabel: t('menu.noNotifications'),
      headerButtonLabel: menuLocale.headerButtonLabel,
      enableAiAgents,
      disableAiHeaderButton: excludeAiHeader && enableAiConversation,
    };

    const pageIcon = crumbs[0] ? crumbs[0].icon : '';
    const hasGoBackButton = crumbs.length >= 2;

    const changePasswordItem = {
      id: profileIds.changePassword,
      leftIcon: 'IconPassword',
      leftIconSize: 'md',
      label: defaultProps.labelChangePassword,
      onClick: () => handleClick({ id: profileIds.changePassword, route: defaultProps.routeChangePassword, label: defaultProps.labelChangePassword }),
    };

    const accountSecurityItem = {
      id: profileIds.accountSecurity,
      leftIcon: 'IconPassword',
      leftIconSize: 'md',
      label: defaultProps.labelAccountSecurity,
      onClick: () => handleClick({ id: profileIds.accountSecurity, route: defaultProps.routeAccountSecurity, label: defaultProps.labelAccountSecurity }),
    };

    const profileItems = () => {
      const items = [
        {
          id: profileIds.myData,
          leftIcon: 'IconData',
          leftIconSize: 'md',
          label: defaultProps.labelMyData,
          onClick: () => handleClick({ id: profileIds.myData, route: defaultProps.routeMyData, label: defaultProps.labelMyData }),
        },
        {
          id: profileIds.serviceStatus,
          leftIcon: 'IconStatus',
          leftIconSize: 'md',
          label: defaultProps.labelServicesStatus,
          onClick: () => handleClick({ id: profileIds.serviceStatus, route: defaultProps.routeServicesStatus, label: defaultProps.labelServicesStatus }),
        },
      ];

      if (moreThanOneUser) {
        items.push({
          id: profileIds.manageUsers,
          leftIcon: 'IconPerfil',
          leftIconSize: 'md',
          label: defaultProps.labelManageUsers,
          onClick: () => handleClick({ id: profileIds.manageUsers, route: defaultProps.routeManageUsers, label: defaultProps.labelManageUsers }),
        });
      }

      items.push({
        id: profileIds.logout,
        leftIcon: 'IconExit',
        leftIconSize: 'md',
        label: defaultProps.labelLogout,
        onClick: () => handleClick({ id: profileIds.logout, route: defaultProps.routeLogout, label: defaultProps.labelLogout }),
      });

      if (!moreThanOneUser) {
        const manageIndex = items.findIndex(item => item.id === profileIds.manageUsers);
        items.splice(manageIndex, 0);
      }

      isAccountSecurityEnabled ? items.splice(1, 0, accountSecurityItem) : items.splice(1, 0, changePasswordItem);

      return (items);
    };

    const financialItems = () => {
      const items = [
        {
          id: financialIds.invoices,
          leftIcon: 'IconInvoice',
          leftIconSize: 'md',
          label: defaultProps.labelInvoices,
          onClick: () => handleClick({ id: financialIds.invoices, route: defaultProps.routesInvoices, label: defaultProps.labelInvoices }),
        },
        {
          id: financialIds.subscriptions,
          leftIcon: 'IconSubscription',
          leftIconSize: 'md',
          label: defaultProps.labelSubscriptions,
          onClick: () => handleClick({ id: financialIds.subscriptions, route: defaultProps.rotutesSubscriptions, label: defaultProps.labelSubscriptions }),
        },
        {
          id: financialIds.creditCard,
          leftIcon: 'IconCreditCard',
          leftIconSize: 'md',
          label: defaultProps.labelCreditCard,
          onClick: () => handleClick({ id: financialIds.creditCard, route: defaultProps.routeCreditCard, label: defaultProps.labelCreditCard }),
        },
      ];

      return items;
    };

    const handleChangeRoute = () => {
      if (redirectedFromHome) {
        history.push(t('routes.home'));
      } else if (history.length) {
        history.goBack();
      } else {
        history.push(crumbs[0].path);
      }
    };

    const pageTitle = () => {
      let title;
      if (hasGoBackButton) {
        title = crumbs[1] && crumbs[1].name;
      }

      if (!hasGoBackButton) {
        title = crumbs[0] && crumbs[0].name;
      }

      if (beta) {
        title = (
          <>
            <Styles.TitleWrapper>
              {title}
            </Styles.TitleWrapper>
            <Tag label="Beta" variant="info" />
          </>
        );
      }


      return title;
    };

    return {
      ...defaultProps,
      handleClick,
      profileItems: profileItems(),
      financialItems: financialItems(),
      handleChangeRoute,
      pageIcon,
      hasGoBackButton,
      pageTitle,
    };
  };

  const getLogoutModalProps = () => {
    const defaultProps = {
      onClose: () => { },
      title: templateLocale.logoutModal.title,
      description: templateLocale.logoutModal.description,
      cta: templateLocale.logoutModal.cta,
    };

    const onClose = () => {
      window.location.href = LOGOUT_URL;
    };

    return {
      ...defaultProps,
      onClose,
    };
  };


  return (
    <div className={classes.root}>
      {hasRefreshError && (
        <LogoutModal {...getLogoutModalProps()} />
      )}

      {enabledAiGuide && <AiGuides />}
      {(viewAiChatGuide || !enabledAiGuide) && <Guides />}

      {isSitePage && domainOptions.length > 0 && (
        <TitanAdvertisementModal
          domainOptions={domainOptions}
          typeAdvertisement={typeAdvertisement}
          displayModal={displayModalTitanAdvertisementHandler}
          setDisplayModal={setDisplayModalTitanAdvertisementHandler}
        />
      )}

      <CssBaseline />
      {!disableHeaderAndMenu && renderMenu()}

      <main ref={mainRef} id="ai-chat-interface-wrapper" className={classes.content}>
        <Styles.HeaderWrapper open={open}>
          {partner && (
            <TopAdvertisementHandler
              ctaLabel={t(`advertisement.top.${partner}.ctaLabel`)}
              title={t(`advertisement.top.${partner}.title`)}
              logo={partnerImages[partner]}
              partnerInfo={partner}
              href={t(`advertisement.top.${partner}.href`)}
            />
          )}
          {!disableHeaderAndMenu && <HeaderV2 {...getHeaderV2Props()} />}
        </Styles.HeaderWrapper>

        <Styles.PageContent disableHeaderAndMenu={disableHeaderAndMenu} open={open}>
          {(useNewChat && !excludeAiHeader && !visibleAiChat && !minimizedChat) && (
            <Styles.NewAiWrapper>
              <Styles.ConversationBox>
                <NewAiHeaderButton hideOnDesktop />
              </Styles.ConversationBox>
            </Styles.NewAiWrapper>
          )}
          <Styles.Container>
            {children}
          </Styles.Container>
        </Styles.PageContent>
      </main>
      {chatbot.isActive && !visibleAiChat && minimizedChat && (
        <SlideInButton
          $visible={(!visibleAiChat && minimizedChat)}
          onClick={() => { !visibleAiChat && chatbot.toggleMinimize(); }}
        >
          <MaiaIcon src={MaiaIconImage || IconAnimation} $marginTop />
          {/* {aichatLocale.name} */}
          Gator
        </SlideInButton>
      )}
      <ModalGtm />
    </div>
  );
};

export default withI18n()(withWidth()(withStyles(styles)(Template)));
